let lang = localStorage.getItem('i18n-lang') || 'en';
console.log(lang, "获取当前语言")
export default {
    // 本地联调：走 vue.config.js 的 /api 代理 -> 本地 PHP(8001) 的 api 应用(Host: dwjapi)
    //baseUrl: '/api',
    // zhoukq线上：
  baseUrl: 'https://wwwwebapi.aohuavet.com',
    // 旧测试域名：'http://dwjapi.wangsjtest.cn',
}
